/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-constant-condition */
/* eslint-disable max-len */
import {
	Box,
	Breadcrumbs,
	Button,
	ButtonGroup,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
	useMediaQuery
} from '@mui/material';
import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Theme } from '@mui/material/styles';
import { PiClockCountdown } from 'react-icons/pi';
import { HiChartBar } from 'react-icons/hi';
import ResopurceIcon from '../../../../../../../assets/SideNavIcons/Resources.svg';
import CustomSearch from '../../../../../../../UiComponents/Search/CustomSearch';
import {
	useNavigate,
	useParams,
	useSearchParams,
	useLocation
} from 'react-router-dom';
import { RiArrowRightSLine } from 'react-icons/ri';
import { LanguageContext } from '../../../../../../../libs/Context';
import ResourceActivitySlider from './ResourceActivitySlider';
import { getCategoryById } from '../../../../../../actions/resource_configuration/category_management';
import { Category } from '../../../../../../actions/resource_configuration/types';
import { RESOURCE_TYPES, ROUTES, UI } from '../../../../../../ResourcesRevised/constants';
import useResourceHelper from './ContentCards/useResourceHelper';
import FavoriteIcon from '@mui/icons-material/Favorite';
// import { roleCondition } from '../../../../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import useContentPermissions from './ContentCards/useContentPermissions';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { getNetworkProfile } from '../../../../../../actions/admin_actions';
import useGetComponentName from '../../../../../../../libs/CustomHooks/useGetCompInfo';

// Reusable BreadcrumbItem component
interface BreadcrumbItemProps {
	text: string;
	isHighlighted?: boolean;
	onClick?: () => void;
	maxWidth?: string;
	showPointer?: boolean;
}

const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
	text,
	isHighlighted = false,
	onClick,
	maxWidth = 'auto',
	showPointer = false
}) =>
{
	const color = isHighlighted ? '#24a4c4' : '#737373';
	const cursor = showPointer ? 'pointer' : 'default';

	return (
		<Box
			sx={{
				maxWidth,
				overflow     : 'hidden',
				textOverflow : 'ellipsis',
				whiteSpace   : 'nowrap',
				cursor
			}}
			onClick={onClick}
		>
			<Typography
				fontSize={'14px'}
				fontWeight={500}
				color={color}
			>
				{text}
			</Typography>
		</Box>
	);
};

const StatusHeader = (props) =>
{
	const { searchValue, setSearchValue = () => {}, isNetworkResource = false,
		breadcrumbData, isResourceView, playlistTitle, hasData = true
	} = props;
	const { language } = useContext(LanguageContext);
	// const { userData } = useSelector((state:any) => state?.mysession?.session);
	// const { userConfigs } = useSelector((state:any) => state?.mysession);
	// eslint-disable-next-line no-unused-vars
	const isMobileSM = useMediaQuery((theme: Theme) =>
		theme.breakpoints.down('md')
	);
	const [ selected, setSelected ] = useState('chart');
	const [ activity, setActivity ] = useState(false);
	const [ categoryData, setCategoryData ] = useState<Category | null>(null);
	const { categoryId } = useParams();
	const location = useLocation();
	const urlCompanyData = location.state?.companyData;
	const [ companyData, setCompanyData ] = useState<any>(urlCompanyData);
	const [ searchParams ] = useSearchParams();
	const isAdminCategories = location.pathname.includes('/businessSettings/content/categories');
	const status = searchParams.get('status') || (isAdminCategories ? 'categories' : ''); // for admin view
	const type = useParams()?.type || ''; // for resource user view
	const companyId = useParams()?.companyId;
	const { isAdminView } = useResourceHelper();
	const showNetworkButton = [ '/resource/network', '/resource' ].includes(location.pathname);
	const isInNetworkResource = location.pathname.includes('/resource/network');
	const isFromCompanyProfile = location.search.includes('from=company_profile');
	const componentName = useGetComponentName(3);
	const statusMapAdmin = {
		drafts        : { currentTxt: 'Drafts', type: 'drafts', route: '/businessSettings/content/section-view?status=drafts' },
		published     : { currentTxt: 'Published', type: 'published', route: '/businessSettings/content/section-view?status=published' },
		scheduled     : { currentTxt: 'Scheduled', type: 'scheduled', route: '/businessSettings/content/section-view?status=scheduled' },
		uncategorized : { currentTxt: 'Uncategorized', type: 'uncategorized', route: '/businessSettings/content/section-view?status=uncategorized' },
		unpublished   : { currentTxt: 'Unpublished', type: 'unpublished', route: '/businessSettings/content/section-view?status=unpublished' },
		playlists     : { currentTxt: 'Playlists', type: 'playlists', route: '/businessSettings/content/section-view?status=playlists' },
		categories    : { currentTxt: 'Categories', type: 'categories', route: '/businessSettings/content/categories' }
	};

	const statusMapUser = {
		favorites  : { currentTxt: 'Favorites', type: 'favorites', route: '/resource/favorites' },
		categories : { currentTxt: 'Categories', type: 'categories', route: '/resource/categories' },
		playlist   : { currentTxt: 'Playlists', type: 'playlists', route: '/resource/playlists' },
		articles   : { currentTxt: 'Articles', type: 'articles', route: '/resource/articles' },
		videos     : { currentTxt: 'Videos', type: 'videos', route: '/resource/videos' },
		podcasts   : { currentTxt: 'Podcasts', type: 'podcasts', route: '/resource/podcasts' },
		documents  : { currentTxt: 'Documents', type: 'documents', route: '/resource/documents' },
		images     : { currentTxt: 'Images', type: 'images', route: '/resource/images' },
		companies  : { currentTxt: 'Companies', type: 'companies', route: '/resource/network/companies' }
	};

	const isNetworkCompany = location.pathname.includes('/resource/network/companies');
	const statusBreadcrumb = isAdminView
		? statusMapAdmin[status]
		: (isNetworkCompany ? statusMapUser.companies : statusMapUser[type]) || { currentTxt: '', type: '', route: '' };
	// Get content type from breadcrumbData for resource view
	const resourceContentType = isResourceView ? breadcrumbData?.contentType : null;

	// Check if we're in resource view detail page
	const isResourceViewDetail = location.pathname.includes('resource/view');

	// Check if category data exists in location state

	const categoryBreadcrumb =
		categoryData?.breadcrumb?.path
			.split('>')
			.map((item, index) => ({
				path       : item,
				categoryId : categoryData?.breadcrumb
					?.pathIds[index]
			})) || [];

	// Function to get the content type from URL
	const getContentTypeFromUrl = () =>
	{
		const pathname = location.pathname;

		if (pathname.includes('article-view')) return 'Article';
		if (pathname.includes('document-view')) return 'Document';
		if (pathname.includes('podcast-view')) return 'Podcast';
		if (pathname.includes('video-view')) return 'Video';
		if (pathname.includes('image-view')) return 'Image';
		if (pathname.includes('playlist-view')) return 'Playlist';

		return null;
	};
	const contentType = getContentTypeFromUrl();
	const highlightStatusBreadcrumb = contentType || categoryBreadcrumb.length || (companyData || companyId);
	const isContentTypeView = Boolean(contentType);
	const showSearch = isInNetworkResource
		? Boolean(companyId) && status !== 'playlists' && !isContentTypeView && !breadcrumbData?.contentType
		: status !== 'playlists' && !isContentTypeView && !breadcrumbData?.contentType;
	const navigate = useNavigate();
	const { hasViewPermission } = useContentPermissions();
	// Function to get company data from localStorage

	const getOtherCompanyData = async () =>
	{
		try
		{
			const query =
				{
					id   : companyId,
					type : 'company'
				};
			const res = await getNetworkProfile(query);

			if (res.status)
			{
				setCompanyData(res?.data || {});
			}
			else
			{
				setCompanyData({});
			}
		}
		catch (err:any)
		{
			console.error('Error fetching company data:', err);
		}
	};
	const getCompanyDataFromStorage = () =>
	{
		try
		{
			const storedData = localStorage.getItem(`companyData_${companyId}`);

			if (storedData)
			{
				const parsedData = JSON.parse(storedData);
				// Check if data is not expired (24 hours)
				const now = new Date().getTime();

				if (parsedData.timestamp && (now - parsedData.timestamp) < 24 * 60 * 60 * 1000)
				{
					return parsedData.data;
				}
			}
		}
		catch (error)
		{
			console.error('Error parsing company data from localStorage:', error);
		}

		return null;
	};

	// Function to store company data in localStorage
	const storeCompanyData = (data: any) =>
	{
		try
		{
			const storageData = {
				data,
				timestamp : new Date().getTime()
			};

			localStorage.setItem(`companyData_${companyId}`, JSON.stringify(storageData));
		}
		catch (error)
		{
			console.error('Error storing company data in localStorage:', error);
		}
	};

	const clearSearch = useCallback(() =>
	{
		setSearchValue('');
	}, [ ]);

	const handleRedirect = () =>
	{
		clearSearch();
		if (statusBreadcrumb?.route)
		{
			navigate(statusBreadcrumb.route);
		}
	};

	const handleBreadcrumbNavigation = (route: string) =>
	{
		clearSearch();
		navigate(route);
	};

	const handleClick = (button) =>
	{
		setSelected(button);
		navigate('/businessSettings/content');
	};
	const handleActivity = () =>
	{
		setActivity(true);
	};

	const fetchCategoryData = async () =>
	{
		const from = isAdminView ? 'Configuration' : 'MyResource';

		if (categoryId)
		{
			try
			{
				const response = await getCategoryById(categoryId, { from });

				setCategoryData(response);
				// Store the response in URL state (not visible to user)
				navigate(location.pathname + location.search, {
					replace : true, state : { categoryData: response }
				});
			}
			catch (error)
			{
				console.error('Error fetching category data:', error);
			}
		}
	};

	useEffect(() =>
	{
		clearSearch();
		fetchCategoryData();

		if (isInNetworkResource && companyId && Object.keys(companyData || urlCompanyData || {}).length === 0)
		{
			getOtherCompanyData();
		}

		return () =>
		{
			setCategoryData(null);
		};
	}, [ categoryId ]);

	useEffect(() =>
	{
		const initializeCompanyData = async () =>
		{
			if (companyId)
			{
				// First try to get from URL state
				if (urlCompanyData)
				{
					setCompanyData(urlCompanyData);
					// Also store in localStorage for future use
					storeCompanyData(urlCompanyData);
				}
				else
				{
					// Try to get from localStorage
					const storedData = getCompanyDataFromStorage();

					if (storedData)
					{
						setCompanyData(storedData);
					}
				}
			}
		};

		initializeCompanyData();
	}, [ urlCompanyData, companyId ]);

	useEffect(() =>
	{
		return () =>
		{
			setCompanyData(null);
		};
	}, [ companyId ]);

	return (
		<Grid
			item
			position={'sticky'}
			top={[ '/resource' ]?.includes(location.pathname) ? 'var(--top64)' : 'var(--top54)'}
			zIndex={99}
			px={2}
			py={1.5}
			justifyContent={'space-between'}
			alignItems={'center'}
			sx={{ backgroundColor: 'var(--whiteColor)' }}
		>
			<Grid item width={'100%'}>
				<Stack direction={'row'} width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
					<Box display='flex' flexWrap={'wrap'} alignItems='center' py={1}>
						{isFromCompanyProfile && (
							<IconButton
								onClick={() => navigate(-1)}
								sx={{ mr: 1 }}
								aria-label='Back'
							>
								<NavigateBeforeIcon />
							</IconButton>
						)}
						{!isResourceViewDetail && (
							<Box
								component='img'
								src={ResopurceIcon}
								sx={{ marginRight: 1 }}
								className='invertPrimary'
								alt=''
								height={'var(--pixel18)'}
								width={'var(--pixel18)'}
							/>
						)}
						<Breadcrumbs aria-label='breadcrumb' separator={<RiArrowRightSLine style={{ marginTop: '2px' }}/>}>
							{/* Content or Resources */}
							<BreadcrumbItem
								text={isAdminView ? language?.content : componentName || ''}
								isHighlighted
								showPointer
								onClick={() => handleBreadcrumbNavigation(isAdminView ? '/businessSettings/content' : isNetworkResource ? '/resource/network' : '/resource')}
							/>
							{/* need to check this */}
							{isResourceView && resourceContentType && (
								<BreadcrumbItem
									text={resourceContentType.charAt(0).toUpperCase() + resourceContentType.slice(1)}
								/>
							)}
							{/* use in both admin and user view */}
							{!isResourceView && statusBreadcrumb?.currentTxt && (
								<BreadcrumbItem
									text={statusBreadcrumb?.currentTxt}
									isHighlighted={highlightStatusBreadcrumb}
									showPointer={highlightStatusBreadcrumb}
									onClick={handleRedirect}
								/>
							)}
							{/* Add playlist title breadcrumb */}
							{!isResourceView && playlistTitle && (
								<BreadcrumbItem
									text={playlistTitle}
									isHighlighted={false}
									showPointer={false}
									maxWidth='200px'
								/>
							)}
							{!isResourceView && (companyData || companyId) && (
							// use in network resources for company name
								<BreadcrumbItem
									text={companyData?.companyName || categoryData?.companyName || 'N/A'}
									isHighlighted={isNetworkCompany && type === 'categories'}
									showPointer={isNetworkCompany && type === 'categories'}
									onClick={() => handleBreadcrumbNavigation(`/resource/network/companies/${companyData?.companyId}`)}
								/>
							)}
							{isNetworkCompany && [ 'categories', 'playlist' ].includes(type) && (
								// use in network resources for categories
								<BreadcrumbItem
									text={type === 'categories' ? 'Categories' : 'Playlists'}
									isHighlighted={categoryBreadcrumb.length > 0}
									showPointer={categoryBreadcrumb.length > 0}
									onClick={() => handleBreadcrumbNavigation(`/resource/network/companies/${companyData?.companyId}/${type === 'categories' ? 'categories' : 'playlists'}`)}
								/>
							)}
							{!isResourceView && contentType && !playlistTitle && (
								// use in admin side for type of content
								<BreadcrumbItem
									text={contentType}
								/>
							)}
							{!isResourceView && categoryBreadcrumb.map((breadcrumb, index) => (
								// use in both admin and user view for category name
								<BreadcrumbItem
									key={index}
									text={breadcrumb.path}
									isHighlighted={index < categoryBreadcrumb.length - 1}
									showPointer={index < categoryBreadcrumb.length - 1}
									maxWidth='200px'
									onClick={() =>
										breadcrumb.categoryId &&
										(isAdminView
											? handleBreadcrumbNavigation(`/businessSettings/content/categories/${breadcrumb.categoryId}`)
											: isNetworkCompany ? handleBreadcrumbNavigation(`/resource/network/companies/${companyData?.companyId}/${type === 'categories' ? 'categories' : 'playlists'}/${breadcrumb.categoryId}`) : handleBreadcrumbNavigation(`/resource/categories/${breadcrumb.categoryId}`))
									}
								/>
							))}
						</Breadcrumbs>
					</Box>
					{!isResourceViewDetail && (
						<Stack
							direction={'row'}
							spacing={2.5}
							alignItems={'center'}
						>
							{showSearch && hasData && (
								<CustomSearch
									placeholder='Search...'
									value={searchValue}
									setValue={setSearchValue}
								/>
							)}

							{!isAdminView && showNetworkButton && <ButtonGroup variant='outlined'>
								<Button
									variant={!location.pathname.includes('/resource/network') ? 'contained' : 'outlined'}
									className={!location.pathname.includes('/resource/network') ? 'whiteTxt' : ''}
									onClick={() =>
									{
										clearSearch();
										navigate('/resource');
									}}
								>
									{language?.myResources}
								</Button>
								<Button
									variant={location.pathname.includes('/resource/network') ? 'contained' : 'outlined'}
									className={location.pathname.includes('/resource/network') ? 'whiteTxt' : ''}
									onClick={() =>
									{
										clearSearch();
										navigate('/resource/network');
									}}
								>
									{language?.networkResources}
								</Button>
							</ButtonGroup>}
							{!companyId && !categoryId && hasViewPermission &&
								<Box display={'flex'} flexDirection={'row'}>
									<Grid item>
										<ButtonGroup
											variant='outlined'
											aria-label='outlined button group'
										>
											<Tooltip
												title={language?.dashboard}
												placement='bottom'
											>
												<Button
													disableElevation
													variant='outlined'
													onClick={() => handleClick('chart')}
													className={selected === 'chart' ? 'whiteTxt' : ''}
													sx={{ padding: '6px 0px ' }}
												>
													<HiChartBar fontSize={'var(--pixel20)'} color={UI.COLORS.PRIMARY} />
												</Button>
											</Tooltip>
										</ButtonGroup>
									</Grid>
								</Box>
							}
							{/* {isAdminView && <Tooltip title='Activity' placement='bottom'>
								<Box
									width={'var(--pixel34)'}
									sx={{ cursor: 'pointer' }}
									height={'var(--pixel34)'}
									borderRadius={'var(--pixel4)'}
									border={'1px solid #24a4c4'}
									display={'flex'}
									justifyContent={'center'}
									alignItems={'center'}
									onClick={handleActivity}
								>
									<PiClockCountdown
										fontSize={'var(--pixel22)'}
										color='var(--primaryColor)'
									/>
								</Box>
							</Tooltip>} */}
							{!isAdminView && <Tooltip title={'Favorites'}>
								<Box
									width={UI.SPACING.PIXEL_32}
									border={`1px solid ${UI.COLORS.BORDER}`}
									height={UI.SPACING.PIXEL_32}
									display={'flex'}
									alignItems={'center'}
									sx={{ cursor: 'pointer' }}
									justifyContent={'center'}
									borderRadius={UI.BORDER_RADIUS.MEDIUM}
									onClick={() => navigate(ROUTES.RESOURCE_FAVORITES)}
								>
									<FavoriteIcon
										sx={{ fontSize : UI.FONT_SIZES.PIXEL_20,
											color    : 'rgb(36, 164, 199)' }}
									/>
								</Box>
							</Tooltip>}
						</Stack>
					)}
				</Stack>
			</Grid>
			{activity && (
				<ResourceActivitySlider
					handleClose={() => setActivity(false)}
					open={activity}
				/>
			)}
		</Grid>
	);
};

export default StatusHeader;